/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_DescriptionInputs */



/**
* | output |
* | --- |
* | "We only notify you when a tournament needs you: table assignments, judge calls, announcements." |
*
* @param {Notifications_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_description = /** @type {((inputs?: Notifications_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous vous notifions seulement quand un tournoi a besoin de vous : placement, appels juge, annonces.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo le avisamos cuando un torneo le necesita: asignación de mesa, llamadas al juez, anuncios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Só avisamos quando um torneio precisa de você: distribuição de mesas, chamadas de juiz, anúncios.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ti avvisiamo solo quando un torneo ha bisogno di te: assegnazione del tavolo, chiamate al giudice, annunci.")
	return /** @type {LocalizedString} */ ("We only notify you when a tournament needs you: table assignments, judge calls, announcements.")
});